import { useEffect, useRef, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";

export interface Props {
    timeoutMs: number;
    warningTimeoutMs: number;
    signOut: any;
}

export default function UserInactivityLogout({timeoutMs, warningTimeoutMs, signOut} : Props) {
    const timeoutRef = useRef<number | null>(null);
    const timeoutWarningRef = useRef<number | null>(null);
    const [open, setOpen] = useState<boolean>(false);

    const handleClose = () => {
        setOpen(false);
    };

    const handleRestart = () => {
        resetTimer();
        handleClose();
    };

    const logout = async () => {
        try {
            await signOut({ global: true }); // invalidate all sessions
        } catch (error) {
            console.error('Error signing out:', error);
        }
    };

    //clearing and resetting to max timeout value
    const resetTimer = () => {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
        }

        if (timeoutWarningRef.current) {
            window.clearTimeout(timeoutWarningRef.current);
        }

        timeoutRef.current = window.setTimeout(() => {
            logout();
        }, timeoutMs);

        timeoutWarningRef.current = window.setTimeout(() => {
            setOpen(true);
        }, warningTimeoutMs);
    };

    //when leaving the tab and returning
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            resetTimer();
        }
    });

    //on launch
    useEffect(() => {
        const events = [
            'mousemove',
            'mousedown',
            'keydown',
            'touchstart',
            'scroll',
        ];

        events.forEach((event) =>
            window.addEventListener(event, resetTimer)
        );

        resetTimer(); // start timer on mount

        return () => {
            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }

            if (timeoutWarningRef.current) {
                window.clearTimeout(timeoutWarningRef.current);
            }

            events.forEach((event) =>
                window.removeEventListener(event, resetTimer)
            );
        };
    }, [timeoutMs]);

    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Inactivity Alert</DialogTitle>

                <DialogContent>
                    <Typography>
                        No user activity has been detected and you will be signed out in 5 minutes with no response.
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleRestart} variant="contained">
                        Stay Signed In
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}